import React from 'react'
import { Link } from 'react-router-dom'
import { Alert, Icon } from '@ztechapps/webui.util'
import { useConversationInboxContext } from './Context'

type MergedConversationNoticeProps = {
  /** The conversation this one was merged into, and its code; no code (a target the caller cannot see) reads as "another conversation". */
  targetId?: string
  targetCode?: string | null
}

// Stands where the reply composer would: a merged conversation takes no reply and no second merge, so
// the one line says why and links to where the conversation continues.
export const MergedConversationNotice = ({ targetId, targetCode }: MergedConversationNoticeProps) => {
  const { conversationItemRoute } = useConversationInboxContext()

  return (
    <div className="flex-shrink-0 border-top pt-3">
      <Alert type="secondary" className="mb-0">
        <Icon name="code-merge" className="me-2" aria-hidden="true" />
        This conversation was merged into{' '}
        {targetId && targetCode ? (
          // A conversation's `externalId` is minted equal to its `_id`, so the route takes the `_id`.
          <Link to={conversationItemRoute.altPath({ _id: targetId })} className="fw-semibold">
            {targetCode}
          </Link>
        ) : (
          'another conversation'
        )}
        . It can no longer be replied to or merged again.
      </Alert>
    </div>
  )
}
